const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const TOKEN_PATTERN = /^\d{6}$/;

export const LATEST_EMAIL_COPY =
  "Use this latest email. Older Activate links no longer work.";

export const CLUB_ALREADY_EXISTS = "Club already exists";

export function activationFailureMessage(error) {
  const data = error?.response?.data ?? {};
  if (
    data.errorCode === "CodeMismatchException" ||
    data.errorCode === "ExpiredCodeException" ||
    data.detail === LATEST_EMAIL_COPY
  ) {
    return LATEST_EMAIL_COPY;
  }
  const raw = data.detail || data.Data || data.Message || "";
  if (raw === CLUB_ALREADY_EXISTS || String(raw).includes("Failed to save club")) {
    return CLUB_ALREADY_EXISTS;
  }
  return raw || "Verification failed";
}

export function normalizeVerificationEmail(email) {
  return String(email ?? "").trim().toLowerCase();
}

export function isValidVerificationEmail(email) {
  return EMAIL_PATTERN.test(normalizeVerificationEmail(email));
}

export function isValidVerificationToken(token) {
  return TOKEN_PATTERN.test(String(token ?? "").trim());
}

export function parseEmailVerificationSearch(search) {
  const params = new URLSearchParams(
    String(search ?? "").startsWith("?") ? search : `?${search ?? ""}`,
  );
  return {
    email: normalizeVerificationEmail(params.get("email")),
    token: String(params.get("token") ?? "").trim(),
  };
}

export function isEmailVerificationLink(search) {
  const { email, token } = parseEmailVerificationSearch(search);
  return isValidVerificationEmail(email) && isValidVerificationToken(token);
}
